import client from './client';
import qs from 'qs';
const departUrl = '/api/v1/common/hrDpt';
const empUrl = '/api/v1/user';

export const getListDepartments = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${departUrl}/list?${queryString}`);
};

//부서 트리 리스트 가져오기
export const getDepartments = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${departUrl}/list/tree?${queryString}`);
};

//부서 추가
export const addDepart = (dataToSubmit) => {
  return client.post(`${departUrl}/info`, dataToSubmit);
};

//부서 정보
export const getDepart = (id) => client.get(`${departUrl}/info/${id}`);

export const editDepart = (id, dataToSubmit) => {
  return client.put(`${departUrl}/info/${id}`, dataToSubmit);
};

//부서 삭제
export const removeDepart = (id) => client.delete(`${departUrl}/info/${id}`);

//부서 사원 리스트
export const getEmpsByDepart = (id, params) => {
  const queryString = qs.stringify(params);
  return client.get(`${empUrl}/dpt/${id}/list?${queryString}`);
};
